import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function FAQs() {
  useEffect(() => { document.title = `FAQs | ${siteConfig.displayName}`; }, []);
  return (
    <main className="policy-page">
      <nav className="legal-tabs" aria-label="Help and legal information">
        <Link className="is-active" to="/faqs">FAQs</Link><Link to="/privacy">Privacy policy</Link><Link to="/cookies">Cookie policy</Link><Link to="/terms">Terms of use</Link>
      </nav>
      <header className="policy-heading"><p className="eyebrow">CUSTOMER CARE</p><h1>Frequently asked questions</h1><p>Answers about ordering, delivery and returns.</p></header>
      <div className="policy-columns">
        <section><h2>How do I choose a size?</h2><p>Use the size options and fit notes on each product page. Contact us before ordering if you need more help.</p><h2>Can I change an order?</h2><p>Email us as soon as possible. We can only change or cancel an order before it enters fulfilment.</p><h2>How can I track delivery?</h2><p>When an order ships, the dispatch email contains the carrier and tracking link.</p></section>
        <section><h2>What is the return window?</h2><p>Eligible unworn items can be returned within 30 days of delivery. Read the <Link to="/returns">returns policy</Link> for conditions.</p><h2>Which payment methods are accepted?</h2><p>Available methods are shown at checkout. Payment authorization is completed securely by the selected provider.</p><h2>How can I contact you?</h2><p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>. Our address is {siteConfig.contact.address}.</p></section>
      </div>
    </main>
  );
}
export default FAQs;
